module.exports = __webpack_public_path__ + "static/media/carousalLeftArrow.1b3c4efe.svg";